import { Injectable, NgZone } from '@angular/core';
import { finalize, take } from 'rxjs';
import { UiService } from './ui.service';

@Injectable({ providedIn: 'root' })
export class AutosaveService {
  private inactivityTimeout = 1000 * 60 * 3;
  private timer: any;
  private savingState = false;

  constructor(private zone: NgZone, private uiService: UiService) { }

  start() {
    // reset clock
    this.tick();
  }

  triggerActivity() {
    // reset clock
    this.tick();
  }

  stop() {
    // clear timer
    if (this.timer) clearTimeout(this.timer);
  }

  private tick() {
    this.zone.runOutsideAngular(() => {
      // 1st Clear timer if exists
      if (this.timer) clearTimeout(this.timer);

      // 2nd start new timer
      this.timer = setTimeout(
        () => this.doSave(),
        this.inactivityTimeout
      );

    });
  }

  private doSave() {
    if (this.savingState) return;
    this.savingState = true;
    this.uiService.saveAll().pipe(
      take(1),
      // reset clock on save complete
      finalize(() => {
        this.savingState = false;
        this.tick();
      })
    ).subscribe();
  }
}
